import RecepcionesNH3 from "./RecepcionesNH3";

export default RecepcionesNH3;
